import React, { useState, useEffect} from 'react'
import cx from 'classnames';
import get from 'lodash/get';

const ModalContext = React.createContext()

const Modal = ({ modal, size }) => {
    return (
        <div className={cx('mlb-modal', `mlb-modal--${size}`)}>
            <div className="mlb-modal_inner">
                {modal}
            </div>
        </div>
    )
}

const ModalProvider = props => {
    const [modal, setModal] = useState();
    const [options, setModalOptions] = useState({size: 'default'});

    useEffect(() => {
        if (!!modal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [modal]);

    return (
        <ModalContext.Provider value={{ setModal, setModalOptions }} {...props} >
            {props.children}
            {modal && <Modal modal={modal} size={get(options, 'size', 'default')}/>}
        </ModalContext.Provider>
    )
}

const useModal = () => {
    const context = React.useContext(ModalContext);
    if (context === undefined) {
        throw new Error('useModal must be used within a ModalProvider')
    }

    return context;
}

export { ModalProvider, useModal }